'use client'
import { useTranslations } from 'next-intl'
import { BaseEmptyStateProps } from '../types'
import { BaseEmptyState } from '../BaseEmptyState'

export const ProductGroupEmptyState: React.FC<BaseEmptyStateProps> = (props) => {
  const t = useTranslations('emptyStates.productGroups')

  return (
    <BaseEmptyState
      {...props}
      title={t('title')}
      description={t('description')}
      imageSrc="/emptyStates/new-product-illustration.svg"
      variant="base"
    />
  )
}
